module.exports = __webpack_public_path__ + "static/media/squared.f2399f31.jpg";